// extracted by mini-css-extract-plugin
export var antSteps = "api-link-module--ant-steps--yihcP";
export var antStepsDot = "api-link-module--ant-steps-dot--AyopF";
export var antStepsHorizontal = "api-link-module--ant-steps-horizontal--nCjvD";
export var antStepsItemDescription = "api-link-module--ant-steps-item-description--8Qvtj";
export var antStepsItemIcon = "api-link-module--ant-steps-item-icon--2OG17";
export var antStepsItemTitle = "api-link-module--ant-steps-item-title--ufia3";
export var antStepsSmall = "api-link-module--ant-steps-small--CTbPQ";
export var antTypography = "api-link-module--ant-typography--5fRhy";
export var hideOnReducedMotion = "api-link-module--hideOnReducedMotion--Xfmpn";
export var noBullet = "api-link-module--noBullet--76dY9";
export var showOnReducedMotion = "api-link-module--showOnReducedMotion--Wra6x";
export var tweetBox = "api-link-module--tweet-box--RMUtb";
export var typeLinkSuffix = "api-link-module--type-link-suffix--g5Weu";